(async () => {
    const { $show, $hide } = await importModule('Utils');
    const { Core } = await importModule('Core');

    customElements.define('collection-loader', class extends Core {
        elements = {
            select: 'x-select',
            input: '[data-sort-input]'
        };

        subscriptions = {
            'collection:loading': '_collectionLoadingHandler',
            'collection:updated': '_collectionUpdatedHandler'
        };

        render() {
            this.subscribe('collection:loading');
            this.subscribe('collection:updated');
        }

        _collectionLoadingHandler() {
            $show(this);
        }

        _collectionUpdatedHandler() {
            $hide(this);
        }

    })
})();